import React from 'react';
import styles from 'LearningManager/styles/UserDashboard.module.scss';
import HeaderRow from 'Pages/TenantProvider/components/HeaderRow';
import OverviewCard from 'LearningManager/components/OverviewCard';
import TrainingSection from 'LearningManager/components/TrainingSection';
import { OVERVIEW_CARDS_DATA } from 'LearningManager/constants/UserDashboard.constants';

const UserDashboard: React.FC = () => {
	return (
		<div>
			<HeaderRow
				title="My Courses"
				subHeading="A quick overview of your assigned training and progress"
				parentClass={styles.header}
			/>
			<div className={styles['overview-section']}>
				{OVERVIEW_CARDS_DATA.map((card) => (
					<OverviewCard
						key={card.id}
						value={card.value}
						label={card.label}
						description={card.description}
						icon={card.icon}
						tooltip={card.tooltip}
					/>
				))}
			</div>
			<div className={styles['training-section']}>
				<TrainingSection />
			</div>
		</div>
	);
};

export default UserDashboard;
